module.exports = __webpack_public_path__ + "static/media/white_instagram.fcce46c6.svg";